import * as styles from './About.module.css';

import SEO from 'src/components/SEO';

export function About() {
  return (
    <>
      <SEO
        title="About miniPT"
        description="Learn more about miniPT's mission to revolutionize personal training and fitness."
        canonicalUrl="/about"
      />
      <div className={styles.container}>
        <h1>About</h1>
      </div>
    </>
  );
}
